import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getMainData } from '../../../actions/settings/main'
import { SettingsContext } from '../../../utils/context'
import { Checkbox, Input, Select, Textarea } from '../../../components/ModalInputs'
import logoSmall from '../../../assets/images/layout/logoSmall.png'
import logoBig from '../../../assets/images/layout/logoBig.png'
import styles from '../styles.module.scss'
import { getSubjects } from '../../../actions/common'
import moment from 'moment'
import { normalizeDate } from '../../../utils/classBook'
import { KLASS_JURNALE, STUDY_PERIOD } from '../../../assets/const'
import Counter from '../../../components/Counter'

const FORMATS = ['общеобразовательная', 'специальная', 'АПИ в процессе']
const FORMATS1 = [1, 2, 3]
const FORMATS2 = ["г.Москва", "г.Санкт-Петербург"]

export default function Main() {

  const dispatch = useDispatch()
  const { main } = useSelector(state => state.settings)
  const { schoolYears, countries, subjects, schools, familyStatuses, familyCompos } = useSelector(state => state.common)

  const { form } = useContext(SettingsContext)

  const { values, handleChange, handleBlur, setFieldValue } = form
  const [amountOfWork, setAmountOfWork] = useState(0);


  useEffect(() => {
    !main && dispatch(getMainData())
    !subjects && dispatch(getSubjects())

  }, [])

  const onCheckCLlick = (e) => setFieldValue(e.target.name, Number(!values[e.target.name]))

  return (
    <div className={styles.inputsWrapper}>
      <div>

        <Textarea
          label='Полное название учебного заведения'
          name='GOU_FullName'
          style={{ resize: 'none', width: '750px', height: '100px' }}
          value={values.GOU_FullName}
          onChange={handleChange}
        />
        <Input
          label='Сокращенное название'
          name='GOU_ShortName'
          style={{ width: '350px' }}
          value={values.GOU_ShortName}
          onChange={handleChange}
        />
        <Textarea
          label='Заголовок для отчетов'
          name='GOU_Name'
          style={{ resize: 'none', width: '750px', height: '100px' }}
          value={values.GOU_Name}
          onChange={handleChange}
        />
      </div>
      <div className={styles.mainMain}>
        <Textarea
          label='Название департамента'
          name='Dep_Name'
          style={{ resize: 'none', width: '250px', height: '100px' }}
          value={values.Dep_Name}
          onChange={handleChange}
        />
        <div style={{ width: '150px', height: '100px' }} >
          <img src={logoSmall} alt='o_O' style={{ width: '150px', height: '100px' }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>

          <div style={{ display: 'flex' }}>
            <Input
              label='Код по ОКПО'
              name='OKPO'
              style={{ width: '150px' }}
              value={values.OKPO}
              onChange={handleChange}
            />
            <Select
              label='Тип образовательной организации'
              name='year'
              value={values.year}
              onChange={handleChange}
            >
              {FORMATS.map(format => <option key={format}>{format}</option>)}
            </Select>
          </div>
          <div style={{ display: 'flex', marginTop: '10px' }}>
            <Checkbox
              label='Образовательная организация МО'
              name='Is_MO_School'
              checked={values?.Is_MO_School}
              onClick={onCheckCLlick}
            />
            <Checkbox
              label='Музыкальная школа'
              style={{ paddingRight: '30px' }}
              name='MusicSchool'
              checked={values?.MusicSchool}
              onClick={onCheckCLlick}
            />
          </div>
        </div>

      </div>
      <div className={styles.mainMain}>
        <div style={{ width: '250px', height: '250px' }}>
          <img src={logoBig} alt='o_O' style={{ width: '250px', height: '250px' }} />
        </div>
        <div>
          <div style={{ display: 'flex' }}>
            <Textarea
              label='Адрес'
              name='address'
              style={{ resize: 'none', width: '450px', height: '100px' }}
              value={values.address}
              onChange={handleChange}
            />
            <Select
              label='Субъект РФ'
              name='ResidingSubject'
              value={(subjects?.find(el => el.subject == values.ResidingSubject))?.subject}
              onChange={handleChange}
            >
              {subjects && subjects.map(format => <option key={format.idsubject}>{format.subject}</option>)}
            </Select>
          </div>
          <div style={{ display: 'flex' }}>
            <Input
              label='Нас. пункт'
              name='ResidingTown'
              style={{ width: '450px' }}
              value={values.ResidingTown}
              onChange={handleChange}
            />
            <Select
              label='Часовой пояс'
              name='time_zone'
              value={values.time_zone}
              onChange={handleChange}
            >
              {FORMATS1.map(format => <option key={format}>{format}</option>)}
            </Select>
          </div>
          <div style={{ display: 'flex' }}>
            <Input
              label='Телефон'
              name='code'
              style={{ width: '150px' }}
              value={values.phones}
              onChange={handleChange}
            />
            <Input
              label='Факс'
              name='code'
              style={{ width: '150px' }}
              value={values.facsimile}
              onChange={handleChange}
            />
            <Input
              label='E-mail'
              name='code'
              style={{ width: '150px' }}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
      <div>
        <div>
          <p>Закрытие журнала</p>
          <div style={{ borderBottom: '2px solid #778AAF', width: "70vw" }}></div>
          <br></br>
          <div className={styles.mainBlock}>
            <Input
              label='Дата закрытия'
              name='educ_periodend'
              value={normalizeDate(values.educ_periodend).format('YYYY-MM-DD')}
              onChange={handleChange}
              type='date'
            />
            <p>Количество дней до блокировки журнала: {values.Days_to_edit_term_grades}</p>
          </div>
          <br></br>
          <div className={styles.mainBlockCheck}>
            <Counter
              className={styles.counter}
              label='Текущие оценки'
              type='number'
              name='num3'
              value={values && values.num3}
              setFieldValue={setFieldValue}
              onKeyPress={e => !/[0-9]/.test(e.key) && e.preventDefault()}
            />
            <div style={{ width: '20px' }}></div>
            <Counter
              className={styles.counter}
              label='Итоговые оценки'
              type='number'
              name='num4'
              value={values && values.num4}
              setFieldValue={setFieldValue}
              onKeyPress={e => !/[0-9]/.test(e.key) && e.preventDefault()}
            />
            <div style={{ width: '20px' }}></div>
            <Checkbox
              label='В том числе ДО и ВД' />
          </div>
          <br></br>
          <div style={{ borderBottom: '2px solid #778AAF', width: "70vw" }}></div>
          <br></br>
          <div className={styles.mainBlock} >
            <Select
              label='Учебный период'
              // name='year'
              // value={values.year}
              onChange={handleChange}
              style={{ width: '300px', marginRight: '30px' }}
            >
              {STUDY_PERIOD.map(format => <option key={format}>{format}</option>)}
            </Select>
            <Select
              label='Кл. журнал(вид)'
              // name='year'
              // value={values.year}
              onChange={handleChange}
              style={{ width: '300px', paddingLeft: '30px' }}
            >
              {KLASS_JURNALE.map(format => <option key={format}>{format}</option>)}
            </Select>
          </div>
          <div className={styles.mainBlockCheck} style={{ marginTop: '20px' }}>
            <Checkbox
              label='Отображать WEB-подвал в киоске'
              name='Show_kiosk_web_footer'
              checked={values?.Show_kiosk_web_footer}
              onClick={onCheckCLlick}
            />
            <div style={{ width: '20px' }}></div>
            <Input
              label='Имя домена AD'
              name='ntlm_domain'
              value={values.ntlm_domain}
              onChange={handleChange}
              style={{ width: '300px', marginRight: '30px' }}
            />
          </div>
          <div className={styles.mainBlockCheck} style={{ marginTop: '20px' }}>
            <Checkbox
              label='Спаренные уроки'
              name='Is_lesson_pair'
              checked={values?.Is_lesson_pair}
              onClick={onCheckCLlick}
            />
            <div style={{ width: '20px' }}></div>
            <Checkbox
              label='Тревожная кнопка'
            />
            <div style={{ width: '20px' }}></div>
            <Input
              label='Макс. размер файлов'
              name='MaxFileSize'
              type='number'
              min='0'
              style={{ width: '80px', marginRight: '5px' }}
              value={values.MaxFileSize}
              onChange={handleChange}
            />
            <span style={{ marginRight: '30px', alignSelf: 'center' }}>Мб</span>
            <Checkbox
              label='Контроль доступа по IP'
            />
          </div>
          <div style={{ marginTop: '20px', display: 'flex', flexDirection: 'column' }}>
            <div>
              <p>Электронный дневник</p>
              <div style={{ borderBottom: '2px solid #778AAF', width: "70vw" }}></div>
              <br></br>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <Checkbox
                label='Отображать файлы дом. заданий родителям'
                name='Parents_show_home_work_files'
                checked={values?.Parents_show_home_work_files}
                onClick={onCheckCLlick}
              />
              <div style={{ width: '20px' }}></div>
              <Checkbox
                label='Не отображать личные данные обучающихся'
                name='HidePersonalInfoInWeb'
                checked={values?.HidePersonalInfoInWeb}
                onClick={onCheckCLlick}
              />
              <div style={{ width: '20px' }}></div>
              <Checkbox
                label='Запрашивать оценку блюд в дневнике'
                name='MusicSchool'
                checked={values?.MusicSchool}
                onClick={onCheckCLlick}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
